// Minimal stub for ValidateAppUserToken used by MediaLibrary.
// If you have a real endpoint, replace this implementation.
import { serviceInstance } from "../axiosinstance";
import { mediaServicesInstance } from "./MediaLib";

export const ValidateAppUserToken = async (userId) => {
  try {
    const response = await mediaServicesInstance.post('MediaLibrary/ActionBasedOnMode', {
      Details: {
        userid: userId,
        token: '',
        Mode: 'ValidateAppUserToken'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error while validating user token:', error);
    throw error;
  }
};

export default { ValidateAppUserToken };
